import parse from 'html-react-parser'
import { TIMER_MARK } from './constants'

export const buildComponents = (content) => content.replace(/(\r\n|\n|\r)/gm, '')
  .split(TIMER_MARK).map(item => parse(item))
